module.exports = __webpack_public_path__ + "static/media/eye.884fc895.svg";